// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/workflow_template_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { ApprovalFlowProcessSetting } from "./approval_flow_model_pb";
import { file_bffuser_v1_approval_flow_model } from "./approval_flow_model_pb";
import type { Member } from "./user_directory_model_pb";
import { file_bffuser_v1_user_directory_model } from "./user_directory_model_pb";
import type { WorkflowTagPoolEntry, WorkflowTemplate, WorkflowTemplateBlockedByAutoCreationRules, WorkflowTemplateDeletable } from "./workflow_template_model_pb";
import { file_bffuser_v1_workflow_template_model } from "./workflow_template_model_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/workflow_template_service.proto.
 */
export const file_bffuser_v1_workflow_template_service: GenFile = /*@__PURE__*/
  fileDesc("CipiZmZ1c2VyL3YxL3dvcmtmbG93X3RlbXBsYXRlX3NlcnZpY2UucHJvdG8SCmJmZnVzZXIudjEiHgocTGlzdFdvcmtmbG93VGVtcGxhdGVzUmVxdWVzdCJQCh1MaXN0V29ya2Zsb3dUZW1wbGF0ZXNSZXNwb25zZRIvCgl0ZW1wbGF0ZXMYASADKAsyHC5iZmZ1c2VyLnYxLldvcmtmbG93VGVtcGxhdGUiMgoaR2V0V29ya2Zsb3dUZW1wbGF0ZVJlcXVlc3QSFAoCaWQYASABKAlCCLpIBXIDsAEBIk0KG0dldFdvcmtmbG93VGVtcGxhdGVSZXNwb25zZRIuCgh0ZW1wbGF0ZRgBIAEoCzIcLmJmZnVzZXIudjEuV29ya2Zsb3dUZW1wbGF0ZSJXCh1DcmVhdGVXb3JrZmxvd1RlbXBsYXRlUmVxdWVzdBI2Cgh0ZW1wbGF0ZRgBIAEoCzIcLmJmZnVzZXIudjEuV29ya2Zsb3dUZW1wbGF0ZUIGukgDyAEBIlAKHkNyZWF0ZVdvcmtmbG93VGVtcGxhdGVSZXNwb25zZRIuCgh0ZW1wbGF0ZRgBIAEoCzIcLmJmZnVzZXIudjEuV29ya2Zsb3dUZW1wbGF0ZSKBAgodVXBkYXRlV29ya2Zsb3dUZW1wbGF0ZVJlcXVlc3QSNgoIdGVtcGxhdGUYASABKAsyHC5iZmZ1c2VyLnYxLldvcmtmbG93VGVtcGxhdGVCBrpIA8gBARI3ChNleHBlY3RlZF91cGRhdGVkX2F0GAIgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIkChJyZW1vdmVkX3RhZ19sYWJlbHMYAyADKAlCCLpIBZIBAhAUEiMKG2F1dG9tYXRpb25fZmllbGRzX3N1cHBvcnRlZBgEIAEoCBIkChxwbGFuX2NyZWF0aW9uX3RpbWVfc3VwcG9ydGVkGAUgASgIIlAKHlVwZGF0ZVdvcmtmbG93VGVtcGxhdGVSZXNwb25zZRIuCgh0ZW1wbGF0ZRgBIAEoCzIcLmJmZnVzZXIudjEuV29ya2Zsb3dUZW1wbGF0ZSJuCh1EZWxldGVXb3JrZmxvd1RlbXBsYXRlUmVxdWVzdBIUCgJpZBgBIAEoCUIIukgFcgOwAQESNwoTZXhwZWN0ZWRfdXBkYXRlZF9hdBgCIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXAiIAoeRGVsZXRlV29ya2Zsb3dUZW1wbGF0ZVJlc3BvbnNlIj4KJkdldFdvcmtmbG93VGVtcGxhdGVEZWxldGFiaWxpdHlSZXF1ZXN0EhQKAmlkGAEgASgJQgi6SAVyA7ABASLXAQonR2V0V29ya2Zsb3dUZW1wbGF0ZURlbGV0YWJpbGl0eVJlc3BvbnNlEjoKCWRlbGV0YWJsZRgBIAEoCzIlLmJmZnVzZXIudjEuV29ya2Zsb3dUZW1wbGF0ZURlbGV0YWJsZUgAEmAKHmJsb2NrZWRfYnlfYXV0b19jcmVhdGlvbl9ydWxlcxgCIAEoCzI2LmJmZnVzZXIudjEuV29ya2Zsb3dUZW1wbGF0ZUJsb2NrZWRCeUF1dG9DcmVhdGlvblJ1bGVzSABCDgoMZGVsZXRhYmlsaXR5IloKKVVwZGF0ZVdvcmtmbG93VGVtcGxhdGVEaXNwbGF5T3JkZXJSZXF1ZXN0Ei0KFG9yZGVyZWRfdGVtcGxhdGVfaWRzGAEgAygJQg+6SAySAQkIASIFcgOwAQEiLAoqVXBkYXRlV29ya2Zsb3dUZW1wbGF0ZURpc3BsYXlPcmRlclJlc3BvbnNlIicKJUdldFdvcmtmbG93VGVtcGxhdGVGb3JtT3B0aW9uc1JlcXVlc3QixQEKJkdldFdvcmtmbG93VGVtcGxhdGVGb3JtT3B0aW9uc1Jlc3BvbnNlEiMKB21lbWJlcnMYASADKAsyEi5iZmZ1c2VyLnYxLk1lbWJlchIyCgh0YWdfcG9vbBgCIAMoCzIgLmJmZnVzZXIudjEuV29ya2Zsb3dUYWdQb29sRW50cnkSQgoSYXBwcm92YWxfcHJvY2Vzc2VzGAMgAygLMiYuYmZmdXNlci52MS5BcHByb3ZhbEZsb3dQcm9jZXNzU2V0dGluZzL/BwoXV29ya2Zsb3dUZW1wbGF0ZVNlcnZpY2USbgoVTGlzdFdvcmtmbG93VGVtcGxhdGVzEiguYmZmdXNlci52MS5MaXN0V29ya2Zsb3dUZW1wbGF0ZXNSZXF1ZXN0GikuYmZmdXNlci52MS5MaXN0V29ya2Zsb3dUZW1wbGF0ZXNSZXNwb25zZSIAEmgKE0dldFdvcmtmbG93VGVtcGxhdGUSJi5iZmZ1c2VyLnYxLkdldFdvcmtmbG93VGVtcGxhdGVSZXF1ZXN0GicuYmZmdXNlci52MS5HZXRXb3JrZmxvd1RlbXBsYXRlUmVzcG9uc2UiABJxChZDcmVhdGVXb3JrZmxvd1RlbXBsYXRlEikuYmZmdXNlci52MS5DcmVhdGVXb3JrZmxvd1RlbXBsYXRlUmVxdWVzdBoqLmJmZnVzZXIudjEuQ3JlYXRlV29ya2Zsb3dUZW1wbGF0ZVJlc3BvbnNlIgAScQoWVXBkYXRlV29ya2Zsb3dUZW1wbGF0ZRIpLmJmZnVzZXIudjEuVXBkYXRlV29ya2Zsb3dUZW1wbGF0ZVJlcXVlc3QaKi5iZmZ1c2VyLnYxLlVwZGF0ZVdvcmtmbG93VGVtcGxhdGVSZXNwb25zZSIAEnEKFkRlbGV0ZVdvcmtmbG93VGVtcGxhdGUSKS5iZmZ1c2VyLnYxLkRlbGV0ZVdvcmtmbG93VGVtcGxhdGVSZXF1ZXN0GiouYmZmdXNlci52MS5EZWxldGVXb3JrZmxvd1RlbXBsYXRlUmVzcG9uc2UiABKMAQofR2V0V29ya2Zsb3dUZW1wbGF0ZURlbGV0YWJpbGl0eRIyLmJmZnVzZXIudjEuR2V0V29ya2Zsb3dUZW1wbGF0ZURlbGV0YWJpbGl0eVJlcXVlc3QaMy5iZmZ1c2VyLnYxLkdldFdvcmtmbG93VGVtcGxhdGVEZWxldGFiaWxpdHlSZXNwb25zZSIAEpUBCiJVcGRhdGVXb3JrZmxvd1RlbXBsYXRlRGlzcGxheU9yZGVyEjUuYmZmdXNlci52MS5VcGRhdGVXb3JrZmxvd1RlbXBsYXRlRGlzcGxheU9yZGVyUmVxdWVzdBo2LmJmZnVzZXIudjEuVXBkYXRlV29ya2Zsb3dUZW1wbGF0ZURpc3BsYXlPcmRlclJlc3BvbnNlIgASiQEKHkdldFdvcmtmbG93VGVtcGxhdGVGb3JtT3B0aW9ucxIxLmJmZnVzZXIudjEuR2V0V29ya2Zsb3dUZW1wbGF0ZUZvcm1PcHRpb25zUmVxdWVzdBoyLmJmZnVzZXIudjEuR2V0V29ya2Zsb3dUZW1wbGF0ZUZvcm1PcHRpb25zUmVzcG9uc2UiAEJAWj5naXRodWIuY29tL2VuZWNoYWluL2ViYWxhbmNlL2dvL2dlbi9wcm90by9iZmZ1c2VyL3YxO2JmZnVzZXJ2MWIGcHJvdG8z", [file_bffuser_v1_approval_flow_model, file_bffuser_v1_user_directory_model, file_bffuser_v1_workflow_template_model, file_buf_validate_validate, file_google_protobuf_timestamp]);

/**
 * ListWorkflowTemplatesRequest carries no organization_id; the BFF handler
 * resolves the organization from the eauth session.
 *
 * @generated from message bffuser.v1.ListWorkflowTemplatesRequest
 */
export type ListWorkflowTemplatesRequest = Message<"bffuser.v1.ListWorkflowTemplatesRequest"> & {
};

/**
 * Describes the message bffuser.v1.ListWorkflowTemplatesRequest.
 * Use `create(ListWorkflowTemplatesRequestSchema)` to create a new message.
 */
export const ListWorkflowTemplatesRequestSchema: GenMessage<ListWorkflowTemplatesRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_template_service, 0);

/**
 * @generated from message bffuser.v1.ListWorkflowTemplatesResponse
 */
export type ListWorkflowTemplatesResponse = Message<"bffuser.v1.ListWorkflowTemplatesResponse"> & {
  /**
   * @generated from field: repeated bffuser.v1.WorkflowTemplate templates = 1;
   */
  templates: WorkflowTemplate[];
};

/**
 * Describes the message bffuser.v1.ListWorkflowTemplatesResponse.
 * Use `create(ListWorkflowTemplatesResponseSchema)` to create a new message.
 */
export const ListWorkflowTemplatesResponseSchema: GenMessage<ListWorkflowTemplatesResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_template_service, 1);

/**
 * @generated from message bffuser.v1.GetWorkflowTemplateRequest
 */
export type GetWorkflowTemplateRequest = Message<"bffuser.v1.GetWorkflowTemplateRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message bffuser.v1.GetWorkflowTemplateRequest.
 * Use `create(GetWorkflowTemplateRequestSchema)` to create a new message.
 */
export const GetWorkflowTemplateRequestSchema: GenMessage<GetWorkflowTemplateRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_template_service, 2);

/**
 * @generated from message bffuser.v1.GetWorkflowTemplateResponse
 */
export type GetWorkflowTemplateResponse = Message<"bffuser.v1.GetWorkflowTemplateResponse"> & {
  /**
   * @generated from field: bffuser.v1.WorkflowTemplate template = 1;
   */
  template?: WorkflowTemplate;
};

/**
 * Describes the message bffuser.v1.GetWorkflowTemplateResponse.
 * Use `create(GetWorkflowTemplateResponseSchema)` to create a new message.
 */
export const GetWorkflowTemplateResponseSchema: GenMessage<GetWorkflowTemplateResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_template_service, 3);

/**
 * @generated from message bffuser.v1.CreateWorkflowTemplateRequest
 */
export type CreateWorkflowTemplateRequest = Message<"bffuser.v1.CreateWorkflowTemplateRequest"> & {
  /**
   * @generated from field: bffuser.v1.WorkflowTemplate template = 1;
   */
  template?: WorkflowTemplate;
};

/**
 * Describes the message bffuser.v1.CreateWorkflowTemplateRequest.
 * Use `create(CreateWorkflowTemplateRequestSchema)` to create a new message.
 */
export const CreateWorkflowTemplateRequestSchema: GenMessage<CreateWorkflowTemplateRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_template_service, 4);

/**
 * @generated from message bffuser.v1.CreateWorkflowTemplateResponse
 */
export type CreateWorkflowTemplateResponse = Message<"bffuser.v1.CreateWorkflowTemplateResponse"> & {
  /**
   * @generated from field: bffuser.v1.WorkflowTemplate template = 1;
   */
  template?: WorkflowTemplate;
};

/**
 * Describes the message bffuser.v1.CreateWorkflowTemplateResponse.
 * Use `create(CreateWorkflowTemplateResponseSchema)` to create a new message.
 */
export const CreateWorkflowTemplateResponseSchema: GenMessage<CreateWorkflowTemplateResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_template_service, 5);

/**
 * UpdateWorkflowTemplateRequest performs a full replacement (PUT semantics).
 * expected_updated_at carries the optimistic-lock baseline.
 *
 * @generated from message bffuser.v1.UpdateWorkflowTemplateRequest
 */
export type UpdateWorkflowTemplateRequest = Message<"bffuser.v1.UpdateWorkflowTemplateRequest"> & {
  /**
   * @generated from field: bffuser.v1.WorkflowTemplate template = 1;
   */
  template?: WorkflowTemplate;

  /**
   * Optimistic-lock baseline. Must match the current updated_at of the
   * record; the server returns ABORTED when they differ. May be omitted
   * (= absent) ONLY while no persisted row exists yet for this id — the first
   * write of a built-in that has not been overlaid or reordered into a row
   * (the server then installs the overlay without an optimistic-lock check).
   * Omitting it once a persisted row exists (an overlaid built-in or a custom
   * template) is a stale-view conflict and the server returns ABORTED.
   *
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 2;
   */
  expectedUpdatedAt?: Timestamp;

  /**
   * removed_tag_labels mirrors internalapi.v1.UpdateWorkflowTemplateRequest
   * (workflow-tag-delete-ui design Decision A/C): labels to strip from
   * EVERY workflow_case + workflow_template default_tags in the
   * authenticated organization, in the same transaction as this update.
   *
   * @generated from field: repeated string removed_tag_labels = 3;
   */
  removedTagLabels: string[];

  /**
   * Set by clients that round-trip SubStep automation fields on this full PUT.
   *
   * @generated from field: bool automation_fields_supported = 4;
   */
  automationFieldsSupported: boolean;

  /**
   * Set by clients that round-trip SubStep.plan_creation_time on this full PUT.
   * Without it, an update of a template that holds a plan creation time is
   * rejected with FAILED_PRECONDITION so that a legacy client cannot erase it.
   *
   * @generated from field: bool plan_creation_time_supported = 5;
   */
  planCreationTimeSupported: boolean;
};

/**
 * Describes the message bffuser.v1.UpdateWorkflowTemplateRequest.
 * Use `create(UpdateWorkflowTemplateRequestSchema)` to create a new message.
 */
export const UpdateWorkflowTemplateRequestSchema: GenMessage<UpdateWorkflowTemplateRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_template_service, 6);

/**
 * @generated from message bffuser.v1.UpdateWorkflowTemplateResponse
 */
export type UpdateWorkflowTemplateResponse = Message<"bffuser.v1.UpdateWorkflowTemplateResponse"> & {
  /**
   * @generated from field: bffuser.v1.WorkflowTemplate template = 1;
   */
  template?: WorkflowTemplate;
};

/**
 * Describes the message bffuser.v1.UpdateWorkflowTemplateResponse.
 * Use `create(UpdateWorkflowTemplateResponseSchema)` to create a new message.
 */
export const UpdateWorkflowTemplateResponseSchema: GenMessage<UpdateWorkflowTemplateResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_template_service, 7);

/**
 * @generated from message bffuser.v1.DeleteWorkflowTemplateRequest
 */
export type DeleteWorkflowTemplateRequest = Message<"bffuser.v1.DeleteWorkflowTemplateRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Optimistic-lock baseline. Must match the current updated_at of the
   * record; the server returns ABORTED when they differ. May be omitted
   * (= absent) ONLY while no persisted row exists yet for this id — deleting a
   * built-in that has not been overlaid or reordered into a row (the server
   * soft-deletes it without an optimistic-lock check). Omitting it once a
   * persisted row exists (an overlaid built-in or a custom template) is a
   * stale-view conflict and the server returns ABORTED.
   *
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 2;
   */
  expectedUpdatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.DeleteWorkflowTemplateRequest.
 * Use `create(DeleteWorkflowTemplateRequestSchema)` to create a new message.
 */
export const DeleteWorkflowTemplateRequestSchema: GenMessage<DeleteWorkflowTemplateRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_template_service, 8);

/**
 * DeleteWorkflowTemplateResponse is intentionally empty (AIP-135).
 *
 * @generated from message bffuser.v1.DeleteWorkflowTemplateResponse
 */
export type DeleteWorkflowTemplateResponse = Message<"bffuser.v1.DeleteWorkflowTemplateResponse"> & {
};

/**
 * Describes the message bffuser.v1.DeleteWorkflowTemplateResponse.
 * Use `create(DeleteWorkflowTemplateResponseSchema)` to create a new message.
 */
export const DeleteWorkflowTemplateResponseSchema: GenMessage<DeleteWorkflowTemplateResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_template_service, 9);

/**
 * GetWorkflowTemplateDeletabilityRequest carries no organization_id; the BFF
 * handler resolves the organization from the eauth session.
 *
 * @generated from message bffuser.v1.GetWorkflowTemplateDeletabilityRequest
 */
export type GetWorkflowTemplateDeletabilityRequest = Message<"bffuser.v1.GetWorkflowTemplateDeletabilityRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message bffuser.v1.GetWorkflowTemplateDeletabilityRequest.
 * Use `create(GetWorkflowTemplateDeletabilityRequestSchema)` to create a new message.
 */
export const GetWorkflowTemplateDeletabilityRequestSchema: GenMessage<GetWorkflowTemplateDeletabilityRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_template_service, 10);

/**
 * @generated from message bffuser.v1.GetWorkflowTemplateDeletabilityResponse
 */
export type GetWorkflowTemplateDeletabilityResponse = Message<"bffuser.v1.GetWorkflowTemplateDeletabilityResponse"> & {
  /**
   * @generated from oneof bffuser.v1.GetWorkflowTemplateDeletabilityResponse.deletability
   */
  deletability: {
    /**
     * Nothing blocks deleting the template.
     *
     * @generated from field: bffuser.v1.WorkflowTemplateDeletable deletable = 1;
     */
    value: WorkflowTemplateDeletable;
    case: "deletable";
  } | {
    /**
     * Workflow auto creation rules use the template.
     *
     * @generated from field: bffuser.v1.WorkflowTemplateBlockedByAutoCreationRules blocked_by_auto_creation_rules = 2;
     */
    value: WorkflowTemplateBlockedByAutoCreationRules;
    case: "blockedByAutoCreationRules";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message bffuser.v1.GetWorkflowTemplateDeletabilityResponse.
 * Use `create(GetWorkflowTemplateDeletabilityResponseSchema)` to create a new message.
 */
export const GetWorkflowTemplateDeletabilityResponseSchema: GenMessage<GetWorkflowTemplateDeletabilityResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_template_service, 11);

/**
 * UpdateWorkflowTemplateDisplayOrderRequest carries the new order of all
 * visible workflow templates for the authenticated organization. The
 * ordered_template_ids list must contain every visible template id exactly once.
 *
 * @generated from message bffuser.v1.UpdateWorkflowTemplateDisplayOrderRequest
 */
export type UpdateWorkflowTemplateDisplayOrderRequest = Message<"bffuser.v1.UpdateWorkflowTemplateDisplayOrderRequest"> & {
  /**
   * @generated from field: repeated string ordered_template_ids = 1;
   */
  orderedTemplateIds: string[];
};

/**
 * Describes the message bffuser.v1.UpdateWorkflowTemplateDisplayOrderRequest.
 * Use `create(UpdateWorkflowTemplateDisplayOrderRequestSchema)` to create a new message.
 */
export const UpdateWorkflowTemplateDisplayOrderRequestSchema: GenMessage<UpdateWorkflowTemplateDisplayOrderRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_template_service, 12);

/**
 * UpdateWorkflowTemplateDisplayOrderResponse is intentionally empty (AIP-135).
 *
 * @generated from message bffuser.v1.UpdateWorkflowTemplateDisplayOrderResponse
 */
export type UpdateWorkflowTemplateDisplayOrderResponse = Message<"bffuser.v1.UpdateWorkflowTemplateDisplayOrderResponse"> & {
};

/**
 * Describes the message bffuser.v1.UpdateWorkflowTemplateDisplayOrderResponse.
 * Use `create(UpdateWorkflowTemplateDisplayOrderResponseSchema)` to create a new message.
 */
export const UpdateWorkflowTemplateDisplayOrderResponseSchema: GenMessage<UpdateWorkflowTemplateDisplayOrderResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_template_service, 13);

/**
 * GetWorkflowTemplateFormOptionsRequest carries no organization_id; the BFF
 * handler resolves the organization from the eauth session.
 *
 * @generated from message bffuser.v1.GetWorkflowTemplateFormOptionsRequest
 */
export type GetWorkflowTemplateFormOptionsRequest = Message<"bffuser.v1.GetWorkflowTemplateFormOptionsRequest"> & {
};

/**
 * Describes the message bffuser.v1.GetWorkflowTemplateFormOptionsRequest.
 * Use `create(GetWorkflowTemplateFormOptionsRequestSchema)` to create a new message.
 */
export const GetWorkflowTemplateFormOptionsRequestSchema: GenMessage<GetWorkflowTemplateFormOptionsRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_template_service, 14);

/**
 * @generated from message bffuser.v1.GetWorkflowTemplateFormOptionsResponse
 */
export type GetWorkflowTemplateFormOptionsResponse = Message<"bffuser.v1.GetWorkflowTemplateFormOptionsResponse"> & {
  /**
   * SubStep 担当者 select 候補 (user_directory_model.proto)
   *
   * @generated from field: repeated bffuser.v1.Member members = 1;
   */
  members: Member[];

  /**
   * 「作成済のタグ」再利用サジェスト + 20 個上限事前チェック用プール
   * (workflow_template_model.proto、ListWorkflowTagPool と同一)
   *
   * @generated from field: repeated bffuser.v1.WorkflowTagPoolEntry tag_pool = 2;
   */
  tagPool: WorkflowTagPoolEntry[];

  /**
   * 承認フローバッジ算出用 (approval_flow_model.proto、GetApprovalFlowSettings と同一)
   *
   * @generated from field: repeated bffuser.v1.ApprovalFlowProcessSetting approval_processes = 3;
   */
  approvalProcesses: ApprovalFlowProcessSetting[];
};

/**
 * Describes the message bffuser.v1.GetWorkflowTemplateFormOptionsResponse.
 * Use `create(GetWorkflowTemplateFormOptionsResponseSchema)` to create a new message.
 */
export const GetWorkflowTemplateFormOptionsResponseSchema: GenMessage<GetWorkflowTemplateFormOptionsResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_template_service, 15);

/**
 * WorkflowTemplateService provides Connect RPCs for managing workflow
 * templates (ワークフロー雛形).
 *
 * @generated from service bffuser.v1.WorkflowTemplateService
 */
export const WorkflowTemplateService: GenService<{
  /**
   * ListWorkflowTemplates returns all workflow templates for the authenticated
   * organization, sorted by display_order ascending, then section business
   * order (単日 → 週間 → 月間 → 年間), then name ascending.
   * Legacy 当日 / 翌日 / 翌々日 share the 単日 rank.
   *
   * @generated from rpc bffuser.v1.WorkflowTemplateService.ListWorkflowTemplates
   */
  listWorkflowTemplates: {
    methodKind: "unary";
    input: typeof ListWorkflowTemplatesRequestSchema;
    output: typeof ListWorkflowTemplatesResponseSchema;
  },
  /**
   * GetWorkflowTemplate returns the full detail of a single workflow template
   * identified by id.
   *
   * @generated from rpc bffuser.v1.WorkflowTemplateService.GetWorkflowTemplate
   */
  getWorkflowTemplate: {
    methodKind: "unary";
    input: typeof GetWorkflowTemplateRequestSchema;
    output: typeof GetWorkflowTemplateResponseSchema;
  },
  /**
   * CreateWorkflowTemplate creates a new workflow template and returns the
   * full detail of the created record.
   *
   * @generated from rpc bffuser.v1.WorkflowTemplateService.CreateWorkflowTemplate
   */
  createWorkflowTemplate: {
    methodKind: "unary";
    input: typeof CreateWorkflowTemplateRequestSchema;
    output: typeof CreateWorkflowTemplateResponseSchema;
  },
  /**
   * UpdateWorkflowTemplate performs a full replacement (PUT semantics) of the
   * workflow template identified by id. Uses optimistic locking via
   * expected_updated_at.
   *
   * @generated from rpc bffuser.v1.WorkflowTemplateService.UpdateWorkflowTemplate
   */
  updateWorkflowTemplate: {
    methodKind: "unary";
    input: typeof UpdateWorkflowTemplateRequestSchema;
    output: typeof UpdateWorkflowTemplateResponseSchema;
  },
  /**
   * DeleteWorkflowTemplate deletes the workflow template identified by id.
   * Uses optimistic locking via expected_updated_at. Returns
   * FAILED_PRECONDITION with google.rpc.ErrorInfo reason
   * WORKFLOW_TEMPLATE_ERROR_REASON_IN_USE_BY_AUTO_CREATION_RULE when
   * workflow auto creation rules use the template (spec AC-WFT-061).
   *
   * @generated from rpc bffuser.v1.WorkflowTemplateService.DeleteWorkflowTemplate
   */
  deleteWorkflowTemplate: {
    methodKind: "unary";
    input: typeof DeleteWorkflowTemplateRequestSchema;
    output: typeof DeleteWorkflowTemplateResponseSchema;
  },
  /**
   * GetWorkflowTemplateDeletability reports whether the workflow template
   * identified by id can be deleted at the time of the call (spec
   * AC-WFT-061). Mirrors internalapi.v1.WorkflowTemplateService.
   *
   * @generated from rpc bffuser.v1.WorkflowTemplateService.GetWorkflowTemplateDeletability
   */
  getWorkflowTemplateDeletability: {
    methodKind: "unary";
    input: typeof GetWorkflowTemplateDeletabilityRequestSchema;
    output: typeof GetWorkflowTemplateDeletabilityResponseSchema;
  },
  /**
   * UpdateWorkflowTemplateDisplayOrder renumbers the display_order values of
   * all visible workflow templates to match the supplied full ordered list of
   * template ids. The caller must supply every visible template id exactly once.
   *
   * @generated from rpc bffuser.v1.WorkflowTemplateService.UpdateWorkflowTemplateDisplayOrder
   */
  updateWorkflowTemplateDisplayOrder: {
    methodKind: "unary";
    input: typeof UpdateWorkflowTemplateDisplayOrderRequestSchema;
    output: typeof UpdateWorkflowTemplateDisplayOrderResponseSchema;
  },
  /**
   * GetWorkflowTemplateFormOptions returns the 3 form-option masters the
   * template editor (新規/編集/複製) needs: members (担当者 select 候補),
   * tag_pool (「作成済のタグ」再利用サジェスト + 20 個上限事前チェック), and
   * approval_processes (承認フローバッジ算出用). Read-only BFF aggregation
   * that fans out to backend UserDirectoryService.ListMembers,
   * WorkflowCaseService.ListWorkflowTagPool, and
   * ApprovalFlowService.GetApprovalFlowSettings.
   *
   * @generated from rpc bffuser.v1.WorkflowTemplateService.GetWorkflowTemplateFormOptions
   */
  getWorkflowTemplateFormOptions: {
    methodKind: "unary";
    input: typeof GetWorkflowTemplateFormOptionsRequestSchema;
    output: typeof GetWorkflowTemplateFormOptionsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bffuser_v1_workflow_template_service, 0);

